import { Link } from "react-router-dom";

export default function Navbar() {
    return (
        <nav className="Navbar">
            <ul className="nav-item"><Link to="/">Home</Link></ul>
            <ul className="nav-item"><Link to="/">Áreas</Link></ul>
            <ul className="nav-item"><Link to="/tags">Tags</Link></ul>
            <ul className="nav-item"><Link to="/">Linha do tempo</Link></ul>
        </nav> 
    );
}
